export default {
  projecttype: '项目类型：',
  timeOut: '本任务时间倒计时',
  all: '全部',
  text: '文本',
  voice: '语音',
  picture: '图片',
  video: '视频',
  typeStr: '类型：',
  duration: '周期：',
  day: '天',
  pubdate: '1个月前发布',
  label: '233人标注中',
  placeholder: 'ID或项目名',
  taskflag0: '暂停',
  taskflag1: '进行中',
  taskflag999: '下线',
  taskflagnil: '未知',
  subStatus10: '进行中',
  // subStatus11: '即将结束',
  // subStatus12: '质检中',
  // subStatus13: '返修中',
  tag: '标注',
  collect: '采集',
  thisType: '数据类型',
  proLimit: '项目权限',
  restricted: '受限',
  open: '开放',
  hasLimit: '我有权限',
  noLimit: '我没有权限',
  please: '请输入内容',
  task: '项目',
  datas: '数据',
  limit: '权限',
  finished: '完成度',
  nodata: '暂无数据',
  mix: '混合',
  nothing: '无',
  release: '发布于',
  just: '刚刚',
  ago: '天前',
  board: '公告栏',
  proType: {
    recruit: '项目招募',
    team: '受限项目',
    personal: '开放项目',
    novice: '新手项目'
  },
  releaseTime: '发布时间：',
  fanhanbi: '泛函币：',
  noData: '暂无数据...',
  num: '剩余：',
  recruit1: '截止时间',
  recruit2: '查看',
  recruit3: '泛函币',
  recruit4: '个人',
  recruit5: '团队',
  recruit6: '联系方式',
  recruit7: '详情介绍',
  recruit8:	'正在招募',
  recruit9:	'招募已满',
  recruit10:	'无效项目'
}



// WEBPACK FOOTER //
// ./src/lang/zh/projects.js